// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * LineString in [GeoJSON](https://datatracker.ietf.org/doc/html/rfc7946) format.
 * @export
 * @interface LineString
 */
export interface LineString {
    /**
     * Type as per GeoJSON, always constant _LineString_.
     * @type {string}
     * @memberof LineString
     */
    readonly type: string;
    /**
     * List of coordinates as [longitude, latitude] resp. easting/northing.
     * @type {Array<Array<number>>}
     * @memberof LineString
     */
    coordinates?: Array<Array<number>>;
}

/**
 * Check if a given object implements the LineString interface.
 */
export function instanceOfLineString(value: object): value is LineString {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function LineStringFromJSON(json: any): LineString {
    return LineStringFromJSONTyped(json, false);
}

export function LineStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineString {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

  export function LineStringToJSON(json: any): LineString {
      return LineStringToJSONTyped(json, false);
  }

  export function LineStringToJSONTyped(value?: Omit<LineString, 'type'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coordinates': value['coordinates'],
    };
}

